export default __webpack_public_path__ + "static/media/nafha1.0e09a08d.jpg";